import { render } from "./IndividualDISCProfile.vue?vue&type=template&id=512a31bd&scoped=true"
import script from "./IndividualDISCProfile.vue?vue&type=script&lang=js"
export * from "./IndividualDISCProfile.vue?vue&type=script&lang=js"

import "./IndividualDISCProfile.vue?vue&type=style&index=0&id=512a31bd&lang=scss"
import "./IndividualDISCProfile.vue?vue&type=style&index=1&id=512a31bd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-512a31bd"

export default script